<template>
  <Modal name="DELETE_SPLIT_CONFIGURATION_MODAL" :title="title" actions>
    <template v-slot:body>
      <p class="mb-1">{{ $t('split.hints.delete') }}</p>
      <v-card class="pa-5 mt-5 grey lighten-3" outlined>
        <v-progress-linear v-if="isSplitConfigurationLoading" indeterminate />
        <span v-else>
          <h6 class="text-uppercase grey--text">
            {{ $t('split.label.vendor') }}
          </h6>
          <p class="mb-0 body-2">{{ splitConfiguration.vendor.name }}</p>

          <v-divider class="my-3 grey lighten-2" />

          <v-row no-gutters>
            <v-col>
              <h6 class="text-uppercase grey--text">
                {{ $t('split.label.host') }}
              </h6>
              <p class="mb-0 body-2">
                {{
                  splitMode(
                    splitConfiguration.host_take_rate,
                    splitConfiguration.host_take_rate_mode
                  )
                }}
              </p>
            </v-col>
            <v-col>
              <h6 class="text-uppercase grey--text">
                {{ $t('split.label.vendor') }}
              </h6>
              <p class="mb-0 body-2">
                {{
                  splitMode(
                    splitConfiguration.customer_take_rate,
                    splitConfiguration.customer_take_rate_mode
                  )
                }}
              </p>
            </v-col>
            <v-col>
              <h6 class="text-uppercase grey--text">
                {{ $t('split.label.hauseful') }}
              </h6>
              <p class="mb-0 body-2">
                {{
                  splitMode(
                    splitConfiguration.hauseful_take_rate,
                    splitConfiguration.hauseful_take_rate_mode
                  )
                }}
              </p>
            </v-col>
            <v-col>
              <h6 class="text-uppercase grey--text">
                {{ $t('split.label.partner') }}
              </h6>
              <p class="mb-0 body-2">
                {{
                  splitMode(
                    splitConfiguration.partner_take_rate,
                    splitConfiguration.partner_take_rate_mode
                  )
                }}
              </p>
            </v-col>
          </v-row>
        </span>
      </v-card>
    </template>
    <template v-slot:actions>
      <v-btn
        @click="closeAllModals"
        :disabled="isSplitConfigurationLoading"
        class="mr-5"
        large
        text
      >
        {{ $t('split.action.cancel') }}
      </v-btn>

      <v-btn
        @click="removeSplitConfiguration(splitConfiguration.id)"
        :loading="isSplitConfigurationLoading"
        class="red"
        large
        dark
        text
      >
        {{ $t('split.action.delete') }}
      </v-btn>
    </template>
  </Modal>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { splitMode } from '../utils'

import Modal from '@/components/app/Modal'

export default {
  name: 'SplitConfigurationDelete',

  components: {
    Modal,
  },

  computed: {
    ...mapGetters(['splitConfiguration', 'isSplitConfigurationLoading']),
  },

  data() {
    return {
      splitMode,
      title: this.$t('split.action.delete'),
    }
  },

  methods: {
    ...mapMutations(['closeAllModals']),
    ...mapActions(['removeSplitConfiguration']),
  },
}
</script>
